export const ICON_SIZE_S = 16
export const ICON_SIZE_M = 24
export const ICON_SIZE_L = 32
export const ICON_SIZE_XL = 48
export const ICON_SIZE_XXL = 64
export const ICON_SIZE_TUTORIAL = 80
